<template>
  <section>
    <template v-if="step === 1">
      <div class="text-center">
        <img src="/static/img/finnix01.png" style="width:100%">
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <h3>ปลดล็อคเรื่องเงินให้ชีวิตติดปีกกับแอปสินเชื่อออนไลน์ฟินนิกซ์</h3>
          <h4>เพิ่มเงินแสนหมุนสบายให้กับคุณแม่บ้าน BeNeat ไม่ต้องใช้เอกสาร ไม่ต้องค้ำประกัน</h4>
          <div class="mt-3">
            <span style="font-weight: 500;">สินเชื่อนาโนฟินนิกซ์ติดปีก (สินเชื่อนาโนไฟแนนซ์) ดียังไง?</span>
            <ul class="ml-4 mt-2">
              <li>สมัครง่าย รู้ผลไว ทำได้เองในแอป</li>
              <li>ให้วงเงินสูงสุด 100,000 บาท</li>
              <li>ดอกเบี้ยต่ำเพียง 2.75% ต่อเดือน</li>
              <li>อนุมัติปั๊บ รับเงินไวสุดใน 5 นาที</li>
              <li>เลือกจ่ายตามใจ ได้เงินไปหมุนต่อทันที</li>
            </ul>
          </div>
          <div class="mt-3 text-danger">
            <span style="font-weight: 500;">พิเศษ! สำหรับคุณแม่บ้าน BeNeat ที่มีประวัติการทำงานดี มีโอกาสได้รับพิจารณาสินเชื่อได้ง่ายขึ้นเพียงมีคุณสมบัติดังต่อไปนี้</span>
            <ul class="ml-4 mt-2">
              <li>รับงานผ่านระบบ BeNeat มาต่อเนื่องอย่างต่ำ 3 เดือนขึ้นไป</li>
              <li>มีประวัติการรับงานคงที่สม่ำเสมอไม่ต่ำกว่า 70 ชม. ต่อเดือนขึ้นไป และต้องได้รับรายได้จาก BeNeat โดยผ่านบัญชีธนาคารที่เป็นชื่อของตนเองเท่านั้น</li>
              <li>มีความรับผิดชอบสูงและไม่มีประวัติรับงานแล้วไม่ไปให้บริการในระยะเวลา 3 เดือนที่ผ่านมา</li>
              <li>มีความซื่อสัตย์ ไม่มีพฤติกรรมการดึงลูกค้าออกนอกระบบ หรือประวัติการรับเงินตรงจากลูกค้า</li>
            </ul>
          </div>
          <div class="mt-3">
            <div>
              <span class="text-muted" style="font-weight: 500;">หมายเหตุ</span>
            </div>
            <div>
              <span class="text-muted">การพิจารณาและอนุมัติสินเชื่อนั้นเป็นไปตามเกณฑ์การพิจารณาของบริษัท มันนิกซ์ จำกัด โดย BeNeat เป็นเพียงผู้ประสานงานและอำนวยความสะดวกในการขอสินเชื่อเท่านั้น</span>
            </div>
          </div>
          <div class="mt-3 text-muted" style="font-size: 85%;">
            สอบถามข้อมูลผลิตภัณฑ์หรือโครงการเพิ่มเติม กรุณาติดต่อศูนย์บริการลูกค้าบริษัทมันนิกซ์ โทร. 02-329-5956
          </div>
          <div class="my-3">
            <div>
              <button class="btn btn-lg btn-block finnix" @click.prevent="next(2)" :disabled="pass === 0">ดำเนินการต่อ</button>
            </div>
            <div class="mt-1" v-if="pass === 0">
              <template v-if="reason">
                <small class="text-muted">{{ reason }}</small>
              </template>
              <template v-else-if="!professionalId">
                <small class="text-muted">เกิดข้อผิดพลาด หากสนใจบริการ กรุณาติดต่อแอดมิน</small>
              </template>
              <template v-else>
                <small class="text-muted">เกิดข้อผิดพลาด หากสนใจบริการ กรุณาติดต่อแอดมิน</small>
              </template>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="step === 2">
      <div class="text-center">
        <img src="/static/img/finnix02.png" style="width:100%">
      </div>
      <div class="row pt-4" style="background-color: #eeeeee;">
        <div class="col-md-12">
          <div class="text-center">
            <h4>กรอกข้อมูลเพื่อเข้าร่วมโครงการ</h4>
          </div>
          <div class="form-group mt-3">
            <div class="form-label" for="tel">กรอกเบอร์โทรศัพท์ที่ท่านได้ลงทะเบียนไว้กับ BeNeat</div>
            <div class="mt-2">
              <input id="tel"
                name="tel"
                class="form-control"
                type="number"
                placeholder="เบอร์โทรศัพท์"
                v-model="tel">
            </div>
          </div>
          <div class="text-center mt-4">
            <h4>ความยินยอมในการเปิดเผยข้อมูล<br>ระหว่าง MONIX และ BeNeat</h4>
          </div>
          <div style="font-size: 85%;">
            <ol class="ml-3 mt-3">
              <li>บริษัท มันนิกซ์ จำกัด ("MONIX") เป็นผู้ให้บริการสินเชื่อส่วนบุคคลภายใต้การกำกับ และผู้ให้บริการสินเชื่อเพื่อการประกอบอาชีพภายใต้การกำกับ ที่ได้รับอนุญาตจากธนาคารแห่งประเทศไทย ผ่านทางแอปพลิเคชันฟินนิกซ์ ("FINNIX") ที่ลูกค้าสามารถยื่นขอสินเชื่อได้ตามกระบวนการที่ระบุในแอปพลิเคชัน</li>
              <li>MONIX และ บริษัท บีนีท จำกัด ("BeNeat") ได้จัดทำโครงการนี้ร่วมกันเพื่อสำรวจความต้องการของลูกค้าของ BeNeat ในผลิตภัณฑ์ประเภทสินเชื่อ และนำข้อมูลที่ได้รับมาพัฒนาผลิตภัณฑ์เพื่อตอบสนองความต้องการของลูกค้าให้ดียิ่งขึ้น</li>
              <li>ในการดำเนินโครงการนี้ BeNeat ("ผู้ควบคุมข้อมูล") จะดำเนินการเก็บรวบรวมข้อมูลส่วนบุคคลของท่านตามที่ท่านได้กรอกในแบบฟอร์มนี้ และขอความยินยอมจากท่านในการเปิดเผยข้อมูลส่วนบุคคลของท่านให้แก่ MONIX ("ผู้รับข้อมูล") ตามรายการข้อมูลที่ระบุในแบบฟอร์มนี้ เพื่อวัตถุประสงค์ในการจัดทำการส่งเสริมการขายและการตลาดร่วมกันระหว่าง MONIX และ BeNeat โดยข้อมูลของท่านจะถูกนำไปใช้เพื่อจัดทำสถิติ วิเคราะห์ช่องทางในการจัดทำการตลาด โฆษณา และพัฒนาผลิตภัณฑ์ที่เกี่ยวข้อง ระหว่าง MONIX และ BeNeat ต่อไป และจะดำเนินการลบหรือทำลายข้อมูลส่วนบุคคลของท่าน เมื่อสิ้นสุดระยะเวลาอันสมควรตามที่ผู้ควบคุมข้อมูลกำหนด</li>
              <li>หากมีข้อสงสัยประการใดเกี่ยวกับผลิตภัณฑ์หรือโครงการ กรุณาติดต่อศูนย์บริการลูกค้าบริษัทมันนิกซ์ โทร 02-329-5956</li>
              <li>หากท่านไม่ประสงค์ที่จะให้ผู้ควบคุมข้อมูลส่วนบุคคลเปิดเผยข้อมูลดังกล่าว กรุณาเลือก "ไม่ยินยอม" โดยท่านยังคงสามารถดาวน์โหลดแอปพลิเคชันฟินนิกซ์ผ่านทาง Google Play Store หรือ Huawei AppGallery ได้</li>
            </ol> 
          </div>
          <div class="panel mb-2" style="background-color: #fefefe;">
            <div class="form-group ml-3 mb-1">
              <div class="checkbox">
                <input type="radio" id="accept" name="accept" :value="1" v-model="accept" v-validate="'required'"/>
                <label class="mb-1 mt-2" for="accept">
                  ยินยอม
                </label>
              </div>
              <div class="checkbox">
                <input type="radio" id="decline" name="accept" :value="0" v-model="accept" v-validate="'required'"/>
                <label class="mb-1" for="decline">
                  ไม่ยินยอม
                </label>
              </div>
            </div>
          </div>
          <div class="my-3">
            <button class="btn btn-lg btn-block finnix" @click.prevent="next(3)" :disabled="accept !== 1">ดำเนินการต่อ</button>
          </div>
        </div>
      </div>
    </template>
    <template v-else-if="step === 3">
      <div class="p-3 finnix-bg">
        <div class="panel p-3" style="background-color: white;">
          ท่านได้ให้ความยินยอมแก่บริษัท บีนีท จำกัด ในการเปิดเผยข้อมูลดังกล่าวให้แก่ บริษัท มันนิกซ์ จำกัด เรียบร้อยแล้ว กรุณาดำเนินการสมัครผ่านแอปพลิเคชันฟินนิกซ์ (FINNIX) ของบริษัท มันนิกซ์ จำกัดต่อไปด้านล่าง เพื่อดาวน์โหลดแอปพลิเคชันฟินนิกซ์ (FINNIX)
        </div>
        <div class="my-3">
          <button class="btn btn-lg btn-block" style="color: white; background-color: #F25942" @click.prevent="download()">ดาวน์โหลดแอปฟินนิกซ์</button>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
  import axios from 'axios'

  export default {
    data () {
      return {
        step: 1,
        pass: 0,
        tel: '',
        reason: null,
        professionalId: null,
        accept: ''
      }
    },
    watch: {
      '$route.query.step' () {
        if (this.$route.query.step) {
          this.step = Number(this.$route.query.step)
        } else {
          this.step = 1
        }
        console.log('DEBUG', this.step)
      }
    },
    methods: {
      async next (step) {
        this.step = step
        if (step === 3) {
          await axios.post(`professionals/${this.professionalId}/finnix`, { tel: this.tel })
        }
        this.$router.push({ path: 'finnix', query: { step } })
      },
      download () {
        window.open('https://play.google.com/store/apps/details?id=com.hahimoney.android.loan&shortlink=2da2cfdf&pid=web-banner&c=web-banner&is_retargeting=true&af_click_lookback=30d')
      },
      async checkCondition () {
        let { data } = await axios.get(`professionals/${this.professionalId}/finnix`)
        if (data.pass) {
          this.pass = 1
        } else if (data.reason) {
          this.reason = data.reason
        }
      }
    },
    async created () {
      if (this.$route.query.professional_id) {
        this.professionalId = this.$route.query.professional_id
      }
      if (this.professionalId) {
        await this.checkCondition()
      }
      if (this.$route.query.step) {
        this.step = Number(this.$route.query.step)
      } else {
        this.step = 1
      }
      console.log('DEBUG', this.step)
    }
  }
</script>

<style scoped>
.finnix {
  color: white;
  background-color: #264A9A;
}
.finnix-bg {
  background-color: #264A9A;
  position: fixed;
  top: 0;
  left: 0;
  min-width: 100%;
  min-height: 100%;
}
.fininx-download-btn {
  background-color: #F25942;
}
</style>


// WEBPACK FOOTER //
// src/components/information/Finnix.vue